export default __webpack_public_path__ + "static/media/Disaster.c1d42b97.svg";